export default __webpack_public_path__ + "static/media/ic_busd_30.f52f9746.svg";